//@ts-nocheck
import clsx from "clsx";
import styles from './title.module.css'
import { useTheme } from "../../utils/theme";

export default function Title({title, width = 100,textAlign = "left", size = null, dynamic = true, lightMode = false}) {

  const { theme } = useTheme();
  // Use passed lightMode prop if explicitly set, otherwise fall back to theme
  const resolvedLightMode = lightMode !== false ? lightMode : theme === "light";

  return  (
    <>
        {/* {title && (<div className={clsx('upper-title', styles["title"])} style={{ width: `${width}%` }}>{title}</div>)} */}
        {title && (<h2 className={clsx('titles', styles["title"], {[styles.light] : resolvedLightMode && dynamic})} style={{ width: `${width}%`, textAlign: textAlign, ...(size && { fontSize: size }) }}>{title}</h2>)}
    </>
)
}